export const DEPLOY_ENV = {
  DEV: "development",
  STAGE: "stage",
  PRE: "pre",
  PROD: "production",
};

export const isProduction = process.env.NODE_ENV === "production";

const DEFAULT_DEPLOY_ENV_NODE_DEV = DEPLOY_ENV.DEV;
const DEFAULT_DEPLOY_ENV_NODE_PROD = DEPLOY_ENV.PROD;

export const defaultDeployEnv = isProduction
  ? DEFAULT_DEPLOY_ENV_NODE_PROD
  : DEFAULT_DEPLOY_ENV_NODE_DEV;

// NOTE: DEPLOY_ENV 來自 Jenkins & Dockerfile 設定
export const deployEnv = process.env.DEPLOY_ENV || defaultDeployEnv;



// WEBPACK FOOTER //
// ./src/constants/environment.js